// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujChip.js
//  SujChip
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// ── Briques d'interface ───────────────────────────────────────────────
export function SujChip({ active, color, children, onClick, title }) {
  const c = color || THEME.gold;
  return (
    <button onClick={onClick} title={title}
      style={{
        background: active ? `${c}22` : "transparent",
        border: `1px solid ${active ? c : THEME.border}`,
        color: active ? c : THEME.textMuted,
        borderRadius: 20, padding: "5px 13px", cursor: "pointer",
        fontSize: 12, fontWeight: active ? 700 : 500, whiteSpace: "nowrap",
      }}>{children}</button>
  );
}
